import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\GetAutomationListController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationListController.php
* @route '/api/automation'
*/
const GetAutomationListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAutomationListController.url(options),
    method: 'get',
})

GetAutomationListController.definition = {
    methods: ["get","head"],
    url: '/api/automation',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Automation\GetAutomationListController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationListController.php
* @route '/api/automation'
*/
GetAutomationListController.url = (options?: RouteQueryOptions) => {
    return GetAutomationListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\GetAutomationListController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationListController.php
* @route '/api/automation'
*/
GetAutomationListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAutomationListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Automation\GetAutomationListController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationListController.php
* @route '/api/automation'
*/
GetAutomationListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAutomationListController.url(options),
    method: 'head',
})

export default GetAutomationListController